import React from 'react';
import Icon from '../../../components/AppIcon';

const BrandHeader = () => {
  return (
    <div className="text-center space-y-4 mb-8">
      <div className="flex items-center justify-center gap-3 mb-6">
        <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center shadow-lg">
          <Icon name="FileText" size={28} color="white" />
        </div>
        <div className="text-left">
          <h1 className="text-2xl font-bold text-foreground">ZentriDMS</h1>
          <p className="text-sm text-muted-foreground">Document Management System</p>
        </div>
      </div>

      <div className="space-y-2">
        <h2 className="text-xl font-semibold text-foreground">
          Welcome Back
        </h2>
        <p className="text-sm text-muted-foreground max-w-md mx-auto">
          Sign in to access your organization's document management platform and collaborate with your team.
        </p>
      </div>

      <div className="flex items-center justify-center gap-6 pt-4">
        <div className="flex items-center gap-2">
          <Icon name="Users" size={16} className="text-primary" />
          <span className="text-xs text-muted-foreground">Team Collaboration</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Brain" size={16} className="text-primary" />
          <span className="text-xs text-muted-foreground">AI-Powered Analysis</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Shield" size={16} className="text-primary" />
          <span className="text-xs text-muted-foreground">Enterprise Security</span>
        </div>
      </div>
    </div>
  );
};

export default BrandHeader;